import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import BonusCard from "./BonusCard";
import BottomNavigation from "../BottomNavigation";
import Footer from "../Home/Footer";

const Bonus = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        style={{
          overflow: "auto",
          height: "calc(100dvh - 80px)",
          WebkitOverflowScrolling: "touch",
          backgroundImage: `url(${require("../../../assets/img/bg.jpg")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          paddingBottom: "calc(120px + env(safe-area-inset-bottom))",
        }}
        className="bg-secondary-500"
      >
        <Helmet>
          <title>{t("TITLE_BONUS")}</title>
        </Helmet>

        <div className="px-4 pt-6 max-w-2xl mx-auto backdrop-blur-lg">
          <BonusCard
            percent="20"
            photo={require("../../../assets/img/home/jackpot3.jpg")}
            badgeLabel={t("BONUS_BADGE_LABEL")}
            title={t("BONUS_SLOT_TITLE")}
            detailsLabel={t("BONUS_DETAILS_TITLE")}
            bg={`url("${require("../../../assets/img/bonus1.jpg")}")`}
            items={[
              t("BONUS_SLOT_ITEM_1"),
              t("BONUS_SLOT_ITEM_2"),
              t("BONUS_SLOT_ITEM_3"),
              t("BONUS_SLOT_ITEM_4"),
              t("BONUS_SLOT_ITEM_5"),
              t("BONUS_SLOT_ITEM_6"),
            ]}
          />

          <BonusCard
            percent="10"
            photo={require("../../../assets/img/home/jackpot1.jpg")}
            badgeLabel={t("BONUS_BADGE_LABEL")}
            title={t("BONUS_LIVECASINO_TITLE")}
            detailsLabel={t("BONUS_DETAILS_TITLE")}
            bg={`url("${require("../../../assets/img/bonus2.jpg")}")`}
            items={[
              t("BONUS_LIVECASINO_ITEM_1"),
              t("BONUS_LIVECASINO_ITEM_2"),
              t("BONUS_LIVECASINO_ITEM_3"),
              t("BONUS_LIVECASINO_ITEM_4"),
              t("BONUS_LIVECASINO_ITEM_5"),
              t("BONUS_LIVECASINO_ITEM_6"),
              t("BONUS_LIVECASINO_ITEM_7"),
            ]}
          />
        </div>

        <Footer />
      </div>

      <BottomNavigation isNavVisible={true} />
    </>
  );
};

export default Bonus;
